module.exports = __webpack_public_path__ + "img/ordCaffeine1.68adc618.jpg";